/**
 * Default Property Editor
 * Fallback editor for control types with no specific editor registered
 * Shows a helpful message and lists available universal properties
 */

import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../registry/PropertyEditor.types';

/**
 * Render function for unknown/unregistered control types
 */
function renderDefaultEditor(props: PropertyEditorProps) {
  const { control } = props;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Control Configuration</h4>
      <p className="af-properties-tab__empty-state">
        No specialized configuration for <strong>{control.type}</strong>. Use other tabs for general properties.
      </p>

      {control.config && Object.keys(control.config).length > 0 && (
        <div className="af-properties-tab__group">
          <label className="af-properties-tab__label">Current Config (JSON)</label>
          <pre className="af-properties-tab__input" style={{
            fontFamily: 'Consolas, Monaco, monospace',
            margin: 0,
            padding: '8px',
            borderRadius: '3px',
            fontSize: '12px',
            overflow: 'auto',
            maxHeight: '200px',
          }}>
            {JSON.stringify(control.config, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}

/**
 * DefaultPropertyEditor - Fallback for unregistered control types
 */
export const DefaultPropertyEditor: PropertyEditor = {
  type: '__default__',
  label: 'Default (No Editor)',
  description: 'Fallback editor for control types with no registered editor',
  render: renderDefaultEditor,
};
